import { gql } from "@apollo/client";
const TEAM_DETAILS_BY_ID = gql`
query teamDetails($id:Int! ) {
    teamDetails(
     id: $id
    )
  }`;
  export default TEAM_DETAILS_BY_ID;